import Vue from 'vue'
import App from './components/AppPublic.vue'
import router from './router/public'
import store from './store/public'

Vue.config.productionTip = false;

if (process.env.NODE_ENV == "production")
	new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount("#app");
else {
	window.app = new Vue({
		router,
		store,
		render: h => h(App)
	}).$mount("#app");
	window.app.store = store	
}